
// import React from "react";
import React, { useCallback, useEffect, useRef, useState } from "react";

import {
  Routes,
  Route,
  Link,
  Navigate,
  useLocation,
  useNavigate,
} from "react-router-dom";
import Cookies from 'js-cookie';
import { Main, PlayerContainer } from "player-components";
import {
  MusicNoteIcon,
  FireIcon,
  AdjustmentsIcon,
  CollectionIcon,
  QuestionMarkCircleIcon,
  CogIcon
} from "@heroicons/react/solid";
import { useSelector, useDispatch } from "react-redux";

// pgw 27-mar-2026 - play all songs in songlist
/*
import {
  selectStatus,
  selectSections,
  selectTitle,
  selectArtist,
  selectSession,
  selectDuration,
  selectPitch,
  selectSpeed,
  changeGlobalPlaybackRate,
  decreaseGlobalPlaybackRate,
  increaseGlobalPlaybackRate,
  changeGlobalPitch,
  decreaseGlobalPitchRate,
  increaseGlobalPitchRate,
  setIsLooping,
  playSong,
  pauseSong,
  stopSong,
  recordSong,
  toggleMasterMute,
  selectPlaybackState,
  selectIsLooping,
  selectLoopStart,
  selectLoopEnd,
  selectIsMasterMuted,
  packSessionAsync,
  mountSessionAndRenderOfflineAsync,
  resetSessionMixerSettings,
  seek,
  unmountSessionAsync,
} from "../../features/session/sessionSlice";
*/

// pgw 27-mar-2026 - play all songs in songlist
import {
  selectStatus,
  selectSections,
  selectTitle,
  selectArtist,
  selectSession,
  selectDuration,
  selectPitch,
  selectSpeed,
  changeGlobalPlaybackRate,
  decreaseGlobalPlaybackRate,
  increaseGlobalPlaybackRate,
  changeGlobalPitch,
  decreaseGlobalPitchRate,
  increaseGlobalPitchRate,
  setIsLooping,
  playSong,
  pauseSong,
  stopSong,
  recordSong,
  toggleMasterMute,
  selectPlaybackState,
  selectIsLooping,
  selectLoopStart,
  selectLoopEnd,
  selectIsMasterMuted,
  packSessionAsync,
  mountSessionAndRenderOfflineAsync,
  resetSessionMixerSettings,
  seek,
  unmountSessionAsync,
  openSession,
} from "../../features/session/sessionSlice";

import {
  createSessionFromSong,
  resetLastCreated,
} from "../../features/setlist/setlistSlice";

import {
	selectSetlistsSetlists,
	replaceAllSetlists,
	saveUserSetlistsToS3Async,
 } from "../../features/setlists/setlistsSlice";


import { selectLibrarySongs, replaceAllLibrarySongs } from "../../features/library/librarySlice";
import store from "../../store";



import { selectUser, setSubscribedAsync, logout, setAuth } from "../../features/auth/authSlice";

import {
  selectSidebarOpen,
  toggleSidebar,
  setNewTrackModalVisible,
  selectFeedbackModalVisible,
  setFeedbackModalVisible,
  selectiOSModalVisible,
  setIOSModalVisible,
  submitFeedback,
  selectClientConfig,
  selectShowLyrics,
  setShowLyrics,
  selectSoloMode,
  setSoloMode,
  selectShowDeveloperTools,
} from "../../features/ui/uiSlice";



// pgw 13-jan-2025
// 
// import Setlist from "../Setlist";
import Setlist from "../SetList";

import CreateSetlist from "../CreateSetlist";
import MySetlist from "../MySetlist";



// pgw 13-jan-2025
// 
// import Setlists from "../Setlists";
import Setlists from "../SetLists";

import Session from "../Session";
import Library from "../Library";
import Help from "../Help";
import Experiments from "../Experiments";
import NotFound from "../NotFound";
import audioEngine from "../../services/audioEngine";

// import { useCallback } from "react";
// import { useEffect } from "react";
// import { useRef } from "react";

// pgw 25-jun-2025 - add offline logic
// import { useRef } from "react";


import FeedbackModal from "../../components/FeedbackModal";
import { useTour } from '@reactour/tour'

import IOSModal from "../../components/IOSModal";
import { selectLyricsLyrics } from "../../features/lyrics/lyricsSlice";
import Settings from "../Settings";

// pgw 30-sep-2025 - replace all debugging debugLog calls with debugLog
import { debugLog } from '../../debugLog';


// pgw 24-aug-2026 - for CG login
import { isCgTestingEnabled } from "../../utils/cgTesting";
import { clearUgcLocalData } from "../../utils/ugcTesting";


// pgw 05-may-2026 - testing ugc
import UgcLibraryEditor from "../UgcLibraryEditor";

// pgw 30-mar-2026
let doprint = false;
// let doprint = true;



// pgw 07-oct-2025
// connectivity probe you can call ad-hoc
async function isReallyOnline1(timeoutMs = 2000) {
	// console.log('isReallyOnline1 p1')
  const controller = new AbortController();
  const t = setTimeout(() => controller.abort('timeout'), timeoutMs);
  try {
    const res = await fetch('/_network-check?t=' + Date.now(), {
      cache: 'no-store',
      credentials: 'omit',
      signal: controller.signal
    });
	// console.log('isReallyOnline1 p2')
    return res.ok;
  } catch {
	// console.log('isReallyOnline1 p3')
    return false;
  } finally {
    clearTimeout(t);
  }
}

async function isReallyOnline2(timeoutMs = 2000) {
	// console.log('isReallyOnline2 p1')
  const controller = new AbortController();
  const t = setTimeout(() => controller.abort('timeout'), timeoutMs);
  try {
    const res = await fetch('/_network-check?t=' + Date.now(), {
      cache: 'no-store',
      credentials: 'omit',
      signal: controller.signal
    });
	// console.log('isReallyOnline2 p2')
    return res.ok;
  } catch {
	// console.log('isReallyOnline2 p3')
    return false;
  } finally {
    clearTimeout(t);
  }
}



const Authenticated = ({ parentVersion, context, config }) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { setIsOpen } = useTour()

  const pitch = useSelector(selectPitch);
  const speed = useSelector(selectSpeed);
  const playbackState = useSelector(selectPlaybackState);
  const isLooping = useSelector(selectIsLooping);
  const loopStart = useSelector(selectLoopStart);
  const loopEnd = useSelector(selectLoopEnd);
  const duration = useSelector(selectDuration);
  const sections = useSelector(selectSections);
  const isMasterMuted = useSelector(selectIsMasterMuted);
  const title = useSelector(selectTitle);
  const artist = useSelector(selectArtist);
  const currentUser = useSelector(selectUser);
  const sidebarOpen = useSelector(selectSidebarOpen);

  // pgw 27-mar-2026 - play all songs in songlist
  const currentPositionInterval = useRef(null);
  const setlistAutoplayLockRef = useRef(false);
  const lastAutoplaySessionIdRef = useRef(null);
  const pendingAutoplaySessionIdRef = useRef(null);

  const setlistPlayActiveRef = useRef(false);
  const [setlistPlayActiveUi, setSetlistPlayActiveUi] = useState(false);
  const [setlistIndicatorStyle, setSetlistIndicatorStyle] = useState(null);

  const status = useSelector(selectStatus);
  const session = useSelector(selectSession);
  const feedbackModalVisible = useSelector(selectFeedbackModalVisible);



  // pgw 27-mar-2026 - play all songs in songlist
  const setlists = useSelector(selectSetlistsSetlists);
  const librarySongs = useSelector(selectLibrarySongs);

  const iOSModalVisible = useSelector(selectiOSModalVisible);
  const clientConfiguration = useSelector(selectClientConfig);
  const showLyrics = useSelector(selectShowLyrics);
  const songLyricsLyrics = useSelector(selectLyricsLyrics);
  const soloMode = useSelector(selectSoloMode);
  const showDeveloperTools = useSelector(selectShowDeveloperTools);


/*
function handleLogoClick(e) {
  e.preventDefault(); // stop default link navigation

  if (shouldNavigateToExternalSite()) {
    window.location.href = clientConfiguration.images.menuLogoLink;
  } else {
    // for example, open an in-app menu or route internally
    // console.log('Decided not to navigate externally');
    // e.g. navigate('/home') if using react-router
  }
}

function shouldNavigateToExternalSite() {
  // Your decision logic here
  // Example: skip external link when offline or VPN suspected
  return navigator.onLine && !window.__CONNECTIVITY_STATUS__?.suspect;
}
*/

function logoNav() {
	// console.log('logoNav p1, clientConfiguration.images.menuLogoLink = ', clientConfiguration.images.menuLogoLink)
  // This preserves existing behaviour
  window.location.href = clientConfiguration.images.menuLogoLink;
	// console.log('logoNav p2')
}


  const handleLogoLinkTest = async (e) => {
		// console.log('handleLogoLinkTest p1, e = ', e)
	e.preventDefault(); // stop default link navigation

	// pgw 07-oct-2025
	const ok = await isReallyOnline1(2500);
		// console.log('handleLogoLinkTest p2, ok = ', ok)
	if (ok) {
		debugLog('user is online')
	}
	else {
		debugLog('user is offline !!')

		let confStr = "You are offline !"
		confStr = confStr + "\n" + "It is not possible to go to the Choir Player web site while you are offline."
		confStr = confStr + "\n" + "\n" + "Are you sure you want to continue ?"
		confStr = confStr + "\n" + "(OK to continue; Cancel to do nothing)"

		let res = confirm(confStr)
		if (res) {
			debugLog("You pressed OK!");
		} else {
			debugLog("You pressed Cancel - returning...");
			return;
		}

	}
		// console.log('handleLogoLinkTest p3 before navigate')

	navigate(`${clientConfiguration.images.menuLogoLink}`);

		// console.log('handleLogoLinkTest p4 after navigate')

    // window.location.href = clientConfiguration.images.menuLogoLink;

  }




  const handleLoginLogout = async () => {

	if (doprint) console.log("pgw handleLoginLogout p21")



	// pgw 07-oct-2025
	const ok = await isReallyOnline2(2500);
	if (ok) {
		console.log('user is online')
	}
	else {
		console.log('user is offline !!')

		let confStr = "You are offline !"
		confStr = confStr + "\n" + "It is not possible to login or logout while you are offline."
		confStr = confStr + "\n" + "\n" + "Are you sure you want to continue ?"
		confStr = confStr + "\n" + "(OK to continue; Cancel to do nothing)"

		let res = confirm(confStr)
		if (res) {
			console.log("You pressed OK!");
		} else {
			console.log("You pressed Cancel - returning...");
			return;
		}

	}

	if (doprint) console.log('pgw handleLoginLogout isCgTestingEnabled()isCgTestingEnabled() ', isCgTestingEnabled())

	if (isCgTestingEnabled()) {

	dispatch(replaceAllSetlists([]));
	dispatch(replaceAllLibrarySongs([]));
	clearUgcLocalData();


	  if (!currentUser?.guest) {
		window.localStorage.removeItem("AUTH_TOKEN");
		dispatch(replaceAllSetlists([]));
		dispatch(replaceAllLibrarySongs([]));
		clearUgcLocalData();


		dispatch(logout({
		  user: {
			ID: "choirgenius-guest",
			displayName: "Guest User",
			subscribed: false,
			guest: true,
			choirGenius: true,
		  },
		}));
		navigate("/");
	  } else {
		navigate("/login");
	  }

	  dispatch(unmountSessionAsync());
	  return;
	}


	// pgw 24-may-2024 testing
	debugLog("pgw handleLoginLogout clientConfiguration.features.auth.mode = ", clientConfiguration.features.auth.mode)
    if (clientConfiguration.features.auth.mode === "domainCookie") {

	  if (isCgTestingEnabled()) {
		if (!currentUser?.guest) {

		  window.localStorage.removeItem("AUTH_TOKEN");
		  dispatch(replaceAllSetlists([]));
		  dispatch(replaceAllLibrarySongs([]));
		  clearUgcLocalData();
		  dispatch(logout({
			user: {
			  ID: "choirgenius-guest",
			  displayName: "Guest User",
			  subscribed: false,
			  guest: true,
			  choirGenius: true,
			},
		  }));
		  navigate("/");
		} else {
		  navigate("/login");
		}

		return;
	  }

      const session_id = Cookies.get(clientConfiguration.features.auth.domainCookie.cookieId);

	  debugLog("pgw handleLoginLogout clientConfiguration.features.auth.domainCookie.cookieId = ", clientConfiguration.features.auth.domainCookie.cookieId)
	  debugLog("pgw handleLoginLogout session_id = ", session_id)
	  debugLog("pgw handleLoginLogout currentUser = ", currentUser)
	  debugLog("pgw handleLoginLogout currentUser?.guest = ", currentUser?.guest)
	  debugLog("pgw handleLoginLogout clientConfiguration.features.auth.domainCookie.logoutUrl = ", clientConfiguration.features.auth.domainCookie.logoutUrl)
	  debugLog("pgw handleLoginLogout clientConfiguration.features.auth.domainCookie.loginUrl = ", clientConfiguration.features.auth.domainCookie.loginUrl)

	  // pgw 04-jun-2024
	  // Fix bug where logout request is never made because browser caches it

      if (!currentUser?.guest) {
	    debugLog("pgw handleLoginLogout p2")


	    if (doprint) console.log("pgw handleLoginLogout p2a - syncing setlists before logout")

        if (window.localStorage.getItem("saveSetlists") === "1") {
          if (doprint) console.log("[SETLISTS S3] saving setlists before logout");
          await dispatch(saveUserSetlistsToS3Async()).unwrap();
        }

  		dispatch(replaceAllSetlists([]));
  		dispatch(replaceAllLibrarySongs([]));
  		clearUgcLocalData();

		var newlocNoCache = clientConfiguration.features.auth.domainCookie.logoutUrl + "?c=" + (new Date()).valueOf();


	    debugLog("pgw handleLoginLogout p2a newlocNoCache = ", newlocNoCache)
        window.location.href = newlocNoCache
        // window.location.href = clientConfiguration.features.auth.domainCookie.logoutUrl;
      } else {
	    debugLog("pgw handleLoginLogout p3")
        if (session_id) {
	      debugLog("pgw handleLoginLogout p4")
          dispatch(setSubscribedAsync(session_id));
        } else {
	      debugLog("pgw handleLoginLogout p5")
          window.location.href = clientConfiguration.features.auth.domainCookie.loginUrl;
        }
      }
    }
	debugLog("pgw handleLoginLogout p6")
    dispatch(unmountSessionAsync());
  }

  const handleToggleSidebar = () => {
    dispatch(toggleSidebar(!sidebarOpen));
  };

  // redirect users to library if no login required
  useEffect(() => {
    if (clientConfiguration.features.auth.mode === "domainCookie") {
      if (location.pathname === "/") {
        navigate("/library");
      }
    }
  }, [location, navigate, clientConfiguration.features.auth.mode]);

  useEffect(() => {
    currentPositionInterval.current = 0;
  }, []);


  // pgw 27-mar-2026 - play all songs in songlist
  const isSetlistOfflineReadyOld = useCallback((setlistId) => {
	const currentSetlist = (setlists || []).find((s) => s.id === setlistId);
	if (!currentSetlist?.items?.length) return false;

	return currentSetlist.items.every((item) => {
	  const song = (librarySongs || []).find((s) => s.songId === item.songId) || item;

	  // adjust this if your real field name differs
	  return song?.onDevice === true;
	});
  }, [setlists, librarySongs]);

  // pgw 27-mar-2026 - play all songs in songlist
  const isSetlistOfflineReady = useCallback((setlistId) => {
	const currentSetlist = (setlists || []).find((s) => s.id === setlistId);
	return currentSetlist?.cached === true;
  }, [setlists]);

  const logSetlistOfflineState = useCallback((setlistId) => {
	const currentSetlist = (setlists || []).find((s) => s.id === setlistId);

	if (doprint) console.log("[AUTOPLAY OFFLINE CHECK]", {
	  setlistId,
	  cached: currentSetlist?.cached,
	  itemCount: currentSetlist?.items?.length,
	  title: currentSetlist?.title,
	});

  }, [setlists]);

  // pgw 27-mar-2026 - play all songs in songlist
  const handlePlayNextSetlistSong = useCallback(async () => {

	try {

		const origin = session?.origin;

		if (doprint) console.log("[AUTOPLAY ORIGIN]", {
		  sessionId: session?.id,
		  origin,
		  originType: origin?.type,
		  setlistId: origin?.setlistId,
		  itemIx: origin?.itemIx,
		});

		if (!origin || origin.type !== "setlist") {
			if (doprint) console.log("[AUTOPLAY ORIGIN] p1 returning");
			return;
		}


		const setlistId = origin.setlistId;
		const currentItemIx = origin.itemIx;

		if (doprint) console.log("[AUTOPLAY NEXT] origin details", {
		  setlistId,
		  currentItemIx,
		});

		logSetlistOfflineState(setlistId);

		if (!isSetlistOfflineReady(setlistId)) {
		  console.warn("[AUTOPLAY NEXT] abort - setlist is not fully offline-ready", {
			setlistId,
		  });
		  setlistAutoplayLockRef.current = false;
		  return;
		}


		if (!setlistId && setlistId !== "") {
			console.warn("[AUTOPLAY] setlistId not defined or is empty string", {
			  setlistId,
			  nextItemIx,
			  songId,
			});
			setlistAutoplayLockRef.current = false;
			pendingAutoplaySessionIdRef.current = null;
			return;
		}


		if (typeof currentItemIx !== "number") {
			console.warn("[AUTOPLAY] typeof currentItemIx != number", {
			  setlistId,
			  nextItemIx,
			  songId,
			});
			setlistAutoplayLockRef.current = false;
			pendingAutoplaySessionIdRef.current = null;
			return;
		}


		const currentSetlist = (setlists || []).find(s => s.id === setlistId);
		if (!currentSetlist?.items?.length) {
			console.warn("[AUTOPLAY] !currentSetlist?.items?.length", {
			  setlistId,
			  nextItemIx,
			  songId,
			});
			setlistAutoplayLockRef.current = false;
			pendingAutoplaySessionIdRef.current = null;
			return;
		}


		const nextItemIx = currentItemIx + 1;

		// End of setlist: stop here

		if (nextItemIx >= currentSetlist.items.length) {
		  if (doprint) console.log("[AUTOPLAY NEXT] reached end of setlist");
		  setlistPlayActiveRef.current = false;
		  setSetlistPlayActiveUi(false);
		  setlistAutoplayLockRef.current = false;
		  pendingAutoplaySessionIdRef.current = null;
		  dispatch(stopSong());
		  return;
		}


		if (doprint) console.log("[AUTOPLAY ORIGIN] p5");

		const nextItem = currentSetlist.items[nextItemIx];
		if (!nextItem) {
		  console.warn("[AUTOPLAY NEXT] abort - nextItem missing");
		  setlistAutoplayLockRef.current = false;
		  pendingAutoplaySessionIdRef.current = null;
		  return;
		}

		if (doprint) console.log("[AUTOPLAY ORIGIN] p6");


		const songId = nextItem.songId;
		const song = (librarySongs || []).find(s => s.songId === songId) || nextItem;

		if (doprint) console.log("[AUTOPLAY ORIGIN] p7");


		if (!song) {
		  console.warn("[AUTOPLAY] next song not found in library/setlist", {
			setlistId,
			nextItemIx,
			songId,
		  });
		  setlistAutoplayLockRef.current = false;
		  pendingAutoplaySessionIdRef.current = null;
		  return;
		}
		const restoreSettings = nextItem?.itemSettings || null;
		if (doprint) console.log("[AUTOPLAY NEXT] restoreSettings", restoreSettings);


		await dispatch(createSessionFromSong({
		  song,
		  title: song.mix,
		  restoreSettings,
		  origin: {
			type: "setlist",
			setlistId,
			itemIx: nextItemIx,
			songId: song.songId || songId,
		  },
		}));

		const newId = store.getState().setlist?.lastCreatedSession;
		const created = store.getState().setlist?.sessions?.find(s => s.id === newId);

		if (!created) {
		  console.warn("[AUTOPLAY NEXT] abort - created session not found");
		  setlistAutoplayLockRef.current = false;
		  pendingAutoplaySessionIdRef.current = null;
		  return;
		}


		dispatch(openSession(created));
		if (doprint) console.log("[AUTOPLAY NEXT] opened session", {
		  createdId: created.id,
		  origin: created.origin,
		});

		dispatch(resetLastCreated());

		if (location.pathname !== "/session") {
		  navigate("/session");
		}

		if (doprint) console.log("[AUTOPLAY NEXT] marking pending autoplay session", created.id);
		pendingAutoplaySessionIdRef.current = created.id;

	} catch (e) {
	  console.error("[AUTOPLAY NEXT ERROR]", e);
	  setlistAutoplayLockRef.current = false;
	  pendingAutoplaySessionIdRef.current = null;
	}


  }, [
	session,
	setlists,
	librarySongs,
	dispatch,
	navigate,
	location.pathname,
	isSetlistOfflineReady,
	logSetlistOfflineState,
  ]);



  useEffect(() => {
	if (!pendingAutoplaySessionIdRef.current) return;
	if (!session?.id) return;
	if (session.id !== pendingAutoplaySessionIdRef.current) return;
	if (status !== "ready") return;

	if (doprint) console.log("[AUTOPLAY READY] pending session is ready, resetting to start and playing", {
	  sessionId: session.id,
	  pendingId: pendingAutoplaySessionIdRef.current,
	  status,
	  currentTime: session?.currentTime,
	});

	pendingAutoplaySessionIdRef.current = null;
	setlistAutoplayLockRef.current = false;
	setlistPlayActiveRef.current = true;
	setSetlistPlayActiveUi(true);

	if (doprint) console.log("[AUTOPLAY READY] before seek", {
	  sessionId: session?.id,
	  sessionCurrentTime: session?.currentTime,
	  audioEngineCurrentPositionMs: audioEngine?.currentPosition,
	});

	dispatch(seek(0));
// 	dispatch(playSong());

	setTimeout(() => {
	  dispatch(playSong());
	}, 50);

  }, [session, status, dispatch]);


  // pgw 27-mar-2026 - play all songs in songlist
  useEffect(() => {
	const interval = setInterval(async () => {
	  if (location.pathname !== "/session") return;
	  if (status !== "ready") return;
	  if (playbackState !== "playing") return;

	  if (isLooping) {
		if (doprint) console.log("[AUTOPLAY SKIP] looping enabled");
		return;
	  }

	  if (!setlistPlayActiveRef.current) {
		if (doprint) console.log("[AUTOPLAY SKIP] setlist play not active");
		return;
	  }


	  const origin = session?.origin;


	  if (!origin || origin.type !== "setlist") {
		if (doprint) console.log("[AUTOPLAY SKIP] origin not defined or origin.type != setlist");
		return;
	  }


	  if (!duration || duration <= 0) {
		if (doprint) console.log("[AUTOPLAY SKIP] duration not defined or duration <= 0");
		return;
	  }

	  if (origin?.setlistId) {
		const offlineReady = isSetlistOfflineReady(origin.setlistId);
		if (!offlineReady) {
		  if (doprint) console.log("[AUTOPLAY SKIP] setlist is not fully offline-ready", {
			setlistId: origin.setlistId,
		  });
		  return;
		}
	  }



	  const currentPositionSeconds = audioEngine.currentPosition / 1000;
	  const durationSeconds = duration;


// 	console.log("[AUTOPLAY] duration = ", duration);
// 	console.log("[AUTOPLAY] durationSeconds = ", durationSeconds);
// 

	  if (session?.id && lastAutoplaySessionIdRef.current !== session.id) {
		lastAutoplaySessionIdRef.current = session.id;
		setlistAutoplayLockRef.current = false;
	  }

	  if (setlistAutoplayLockRef.current) {
		if (doprint) console.log("[AUTOPLAY SKIP] lock is set");
		return;
	  }

	  if (pendingAutoplaySessionIdRef.current) {
		if (doprint) console.log("[AUTOPLAY SKIP] waiting for pending autoplay session to become ready", {
		  pendingId: pendingAutoplaySessionIdRef.current,
		});
		return;
	  }

	  const debugAutoplay =
		window.__DEBUG_AUTOPLAY_10S__ === true ||
		localStorage.getItem("debugAutoplay10s") === "1";

	  if (doprint) console.log("[AUTOPLAY DEBUG MODE]", {
		windowFlag: window.__DEBUG_AUTOPLAY_10S__,
		localStorageFlag: localStorage.getItem("debugAutoplay10s"),
		debugAutoplay,
	  });

	  const debugAutoplaySeconds =
		Number(localStorage.getItem("debugAutoplaySeconds")) || 10;

		/*
	  const hasReachedEnd = debugAutoplay
		? currentPositionSeconds >= debugAutoplaySeconds
		: currentPositionSeconds >= (durationSeconds - 0.25);
		*/

	  const hasReachedEnd = debugAutoplay
		? currentPositionSeconds >= debugAutoplaySeconds
		: currentPositionSeconds >= (durationSeconds - 1.0);


// 	console.log("[AUTOPLAY] currentPositionSeconds = ", currentPositionSeconds);
// 	console.log("[AUTOPLAY] hasReachedEnd = ", hasReachedEnd);


/*
	const tolerance = 0.75;

	const effectivelyFinished =
	  playbackEnded ||
	  currentTime >= actualDuration - tolerance ||
	  currentTime >= expectedDuration - tolerance;

	console.log("[AUTOPLAY] effectivelyFinished = ", effectivelyFinished);
*/

	  if (doprint) console.log("[AUTOPLAY DEBUG]", {
		mode: debugAutoplay ? "debug-seconds" : "end",
		debugAutoplaySeconds,
		currentPositionSeconds,
		durationSeconds,
		sessionId: session?.id,
	  });

	  if (hasReachedEnd) {
		if (doprint) console.log("[AUTOPLAY DEBUG]", {
		  mode: debugAutoplay ? "10s" : "end",
		  currentPositionSeconds,
		  durationSeconds,
		  sessionId: session?.id,
		});

		setlistAutoplayLockRef.current = true;
		await handlePlayNextSetlistSong();
	  }

	}, 200);

	return () => clearInterval(interval);
  }, [
	location.pathname,
	status,
	playbackState,
	isLooping,
	session,
	duration,
	handlePlayNextSetlistSong,
	isSetlistOfflineReady,
  ]);


  useEffect(() => {
	const pendingId = window.__PENDING_AUTOPLAY_SESSION_ID__;

	if (!pendingId) return;
	if (!session?.id) return;
	if (session.id !== pendingId) return;
	if (status !== "ready") return;

	if (doprint) console.log("[PLAY SETLIST] initial session ready, resetting to start and playing", {
	  sessionId: session.id,
	  pendingId,
	  currentTime: session?.currentTime,
	});

	window.__PENDING_AUTOPLAY_SESSION_ID__ = null;
	setlistPlayActiveRef.current = true;
	setSetlistPlayActiveUi(true);
	dispatch(seek(0));
	dispatch(playSong());
  }, [session, status, dispatch]);







useEffect(() => {
  const updateSetlistIndicatorPosition = () => {
    if (!setlistPlayActiveUi) {
      setSetlistIndicatorStyle(null);
      return;
    }

    const sectionButton = document.getElementById("section-button");

    const currentTimeEl =
      document.getElementById("current-time") ||
      document.querySelector('[data-testid="current-time"]');

    const timelineEl =
      document.getElementById("timeline-track") ||
      document.getElementById("timeline") ||
      document.querySelector('[data-testid="timeline-track"]') ||
      document.querySelector('[data-testid="timeline"]') ||
      document.querySelector('[aria-label="Timeline"]') ||
      document.querySelector('[aria-label="timeline"]');

    if (!sectionButton) {
      setSetlistIndicatorStyle(null);
      return;
    }

    const sectionRect = sectionButton.getBoundingClientRect();
    const timelineRect = timelineEl
      ? timelineEl.getBoundingClientRect()
      : sectionRect;

    const leftAnchor = currentTimeEl
      ? currentTimeEl.getBoundingClientRect().left
      : timelineRect.left;

    const viewportWidth = window.innerWidth;
    const maxWidth = Math.min(320, Math.max(160, viewportWidth - leftAnchor - 24));

    setSetlistIndicatorStyle({
      position: "fixed",
      left: leftAnchor + "px",
      top: sectionRect.top + sectionRect.height / 2 + "px",
      transform: "translateY(-50%)",
      zIndex: 2000,
      padding: "6px 10px",
      borderRadius: 6,
      background: "#ffe9a8",
      color: "#333",
      fontSize: viewportWidth < 640 ? 11 : 12,
      fontWeight: 600,
      lineHeight: 1.2,
      whiteSpace: "normal",
      textAlign: "left",
      maxWidth: maxWidth + "px",
      pointerEvents: "none",
      boxSizing: "border-box",
    });
  };

  updateSetlistIndicatorPosition();

  window.addEventListener("resize", updateSetlistIndicatorPosition);
  window.addEventListener("scroll", updateSetlistIndicatorPosition, true);

  const interval = setInterval(updateSetlistIndicatorPosition, 300);

  return () => {
    window.removeEventListener("resize", updateSetlistIndicatorPosition);
    window.removeEventListener("scroll", updateSetlistIndicatorPosition, true);
    clearInterval(interval);
  };
}, [setlistPlayActiveUi, location.pathname, status, session && session.id]);







  const shareSession = async () => {
    await dispatch(packSessionAsync());
  };

  const downloadSession = async () => {
    await dispatch(
      mountSessionAndRenderOfflineAsync({
        cache: clientConfiguration.features.session.cacheOnMount,
      })
    );
  };

  const resetSession = async () => {
    await dispatch(resetSessionMixerSettings());
  };

  const MenuLink = ({ to, label, icon, active, newWindow = false }) => {
    return (
      <Link
        target={newWindow?'_blank': ''}
        className={`text-white ${
          active ? "bg-primary  hover:text-white" : ""
        } hover:text-primary group flex items-center px-2 py-2 text-sm font-medium rounded-md`}
        to={to}
        onClick={() => dispatch(toggleSidebar(false))}
      >
        {icon}
        <span className="ml-1 text-white">{label}</span>
      </Link>
    );
  };

  const VersionNumber = ({ children }) => {
    return (
      <div className={`mt-4 text-white px-2 py-2 text-sm font-medium`}>
        <small>
        {children}</small>
      </div>
    );
  };

  const handleSelectSection = (section) => {};


/*
  const handleUpdatePosition = (position) => {

		console.log(" window.__CHOIRPLAYER_METADATA_EDITOR_OPEN__ = ", window.__CHOIRPLAYER_METADATA_EDITOR_OPEN__);

	if (window.__CHOIRPLAYER_METADATA_EDITOR_OPEN__) {
	  dispatch(seek(position * 1000));
	  return;
	}

	dispatch(playSong());
	dispatch(seek(position * 1000));

  };
*/

/*
  const isMetadataEditorOpen = () => {
	return (
	  window.__CHOIRPLAYER_METADATA_EDITOR_OPEN__ === true ||
	  document.body.dataset.choirplayerMetadataEditorOpen === "1"
	);
  };

  const handleUpdatePosition = (position) => {
	if (isMetadataEditorOpen()) {
	  dispatch(seek(position * 1000));
	  dispatch(pauseSong());
	  return;
	}

	dispatch(playSong());
	dispatch(seek(position * 1000));
  };


*/

  const isMetadataEditorOpen = () => {
	return (
	  window.__CHOIRPLAYER_METADATA_EDITOR_OPEN__ === true ||
	  document.body.dataset.choirplayerMetadataEditorOpen === "1"
	);
  };


/*
  const handleUpdatePosition = (position, options = {}) => {
	if (options.suppressPlay || isMetadataEditorOpen()) {
	  dispatch(seek(position * 1000));
	  dispatch(pauseSong());
	  return;
	}

	dispatch(playSong());
	dispatch(seek(position * 1000));
  };
*/


  const handleUpdatePosition = (position, options = {}) => {
	if (options.suppressPlay) {
	  dispatch(seek(position * 1000));
	  dispatch(pauseSong());
	  return;
	}

	dispatch(playSong());
	dispatch(seek(position * 1000));
  };


  const handleOnLoop = () => {
    let startMs = null;
    let endMs = null;

	debugLog("pgw pgw handleOnLoop isLooping = ", isLooping)

    if (!isLooping) {
      const currentPosition = audioEngine.currentPosition / 1000;

		debugLog("pgw pgw handleOnLoop currentPosition = ", currentPosition)

      if (sections?.length) {
        for (const section of sections) {
          if (
            currentPosition >= section.start &&
            currentPosition < section.end
          ) {
            startMs = section.start * 1000;
            endMs = section.end * 1000;
          }
        }
      }
    }
    dispatch(setIsLooping({ startMs, endMs }));
  };

  const handleFeedbackModalClose = () => {
    dispatch(setFeedbackModalVisible(false));
  };

  const handleFeedbackModalSubmit = (feedback) => {
    dispatch(submitFeedback(feedback));
    dispatch(setFeedbackModalVisible(false));
  };

  const handleIOSModalClose = (feedback) => {
    dispatch(setIOSModalVisible(false));
  };

  const handleSoloModeToggle = () => {
    setIsOpen(false);
    if (soloMode) {
      dispatch(setSoloMode(false));
    } else {
      dispatch(setSoloMode(true));
    }
  }

  const handleMixReset = () => {
// pgw 21-apr-2023
//     debugLog('show tourguide');
//     setIsOpen(true);
    dispatch(setSoloMode(false));
    //set all track volume to  1;
    dispatch(resetSessionMixerSettings());

  }

  const getShouldShowPitchSpeedControls = () => {
    return true;
  };

  const getRouteTitle = () => {
    switch (location.pathname) {
      case "/session":
        return session.status === "ready" ? title : "Session";
      case "/setlist/create":
        return "Create setlist";
      case "/setlists":
        return "Setlists";
      case "/library":
        return "Song library";
      case "/settings":
          return "Settings";
      case "/help":
        return "Help";
      case "/experiments":
        return "Experiments";
      default:
        if (location.pathname.includes("/setlist/")) return "Setlist";
        return "";
    }
  };

  // pgw 27-mar-2026 - play all songs in songlist
  const handleStop = () => {
	if (doprint) console.log("[SETLIST PLAY] stop pressed - disabling setlist play");

	setlistPlayActiveRef.current = false;
	setSetlistPlayActiveUi(false);
	pendingAutoplaySessionIdRef.current = null;
	window.__PENDING_AUTOPLAY_SESSION_ID__ = null;
	setlistAutoplayLockRef.current = false;

	dispatch(stopSong());
  };


  const formNavigationItems = () => {
    let navItems = [];

    navItems.push({
      element: (
        <MenuLink
          to="/session"
          label="Session"
          icon={<AdjustmentsIcon className="h-6 w-6'" />}
          active={location.pathname === "/session"}
        />
      ),
    });

    if (clientConfiguration.features.setlist.enabled) {
      navItems.push({
        element: (
          <MenuLink
            to="/my-setlist"
            label={clientConfiguration.labels.setlist}
            icon={<CollectionIcon className="h-6 w-6'" />}
            active={location.pathname === "/my-setlist"}
          />
        ),
      });
    }

    navItems.push({
      element: (
        <MenuLink
          to="/library"
          label={clientConfiguration.labels.library}
          icon={<MusicNoteIcon className="h-6 w-6'" />}
          active={location.pathname === "/library"}
        />
      ),
    });

    if (clientConfiguration.features.setlists.enabled) {
      navItems.push({
        element: (
          <MenuLink
            to="/setlists"
            label={clientConfiguration.labels.setlists}
            icon={<CollectionIcon className="h-6 w-6'" />}
            active={
              location.pathname === "/setlists" ||
              location.pathname.includes("/setlist/")
            }
          />
        ),
      });
    }

    navItems.push({
      element: (
        <MenuLink
          // newWindow={location.pathname !== '/help' ? true: false}
          to="/help"
          label="Help"
          icon={<QuestionMarkCircleIcon className="h-6 w-6'" />}
          active={location.pathname === "/help"}
        />
      ),
    });
    navItems.push({
      element: (
        <MenuLink
          to="/settings"
          label={<div id="ram-display">Settings</div>}
          icon={<CogIcon className="h-6 w-6'" />}
          active={location.pathname === "/settings"}
        />
      ),
    });

    if (showDeveloperTools) {
      navItems.push({
      element: (
        <MenuLink
          to="/settings"
          label={<div id="ram-display">{window.ramUsage.toUpperCase()} used</div>}
          icon={null}
          active={false}
        />
      )
    });
  }

    navItems.push({
      element: (
        <VersionNumber>v{parentVersion}</VersionNumber>
      )
    });

    return navItems;
  };


// pgw 07-oct-2025
/*

      logoLink={"#"}
      onLogoClick={handleLogoLinkTest}

      logoLink={`${clientConfiguration.images.menuLogoLink}`}


      logoLink={"#"}
      onLogoClick={handleLogoLinkTest}


*/



  let setlistProgressText = null;

  if (setlistPlayActiveUi && session?.origin?.type === "setlist") {
	const setlistId = session.origin.setlistId;
	const currentSetlist = (setlists || []).find((s) => s.id === setlistId);

	if (currentSetlist?.items?.length) {
	  const currentIndex = (session.origin.itemIx ?? 0) + 1;
	  const total = currentSetlist.items.length;

	  setlistProgressText = `Song ${currentIndex}/${total}`;
	} else {
	  setlistProgressText = "Playing setlist";
	}
  }


  return clientConfiguration ? (
    <Main
      logoUrl={`${process.env.PUBLIC_URL}${clientConfiguration.images.menuLogo}`}

      logoLink={`${clientConfiguration.images.menuLogoLink}`}


      backgroundUrl={`${process.env.PUBLIC_URL}${clientConfiguration.images.menuBackground}`}
      navigationItems={formNavigationItems()}
      user={currentUser}
      navigation={[]}
      loginLogoutLabel={
        !currentUser?.guest
          ? clientConfiguration.features.auth[
              clientConfiguration.features.auth.mode
            ].logoutLabel
          : clientConfiguration.features.auth[
              clientConfiguration.features.auth.mode
            ].loginLabel
      }
      onLoginLogout={handleLoginLogout}
      headerContext={{
        currentSong: {
          title: getRouteTitle(),
          artist: artist,
        },
        onShare: shareSession,
        onAddStem: () => dispatch(setNewTrackModalVisible(true)),
        onDownload: downloadSession,
        onReset: resetSession,
        showExtraMenu: false,
        showActionButton:
          songLyricsLyrics &&
          location.pathname === "/session" &&
          status === "ready",
        actionButtonActive: showLyrics,
        onClickedActionButon: () => dispatch(setShowLyrics(!showLyrics)),
      }}
      sidebarOpen={sidebarOpen}
      onToggleSidebar={handleToggleSidebar}
    >

	  {setlistPlayActiveUi && setlistIndicatorStyle && setlistProgressText && (
		<div style={setlistIndicatorStyle}>
		  {setlistProgressText}
		</div>
	  )}


	  <PlayerContainer
		showPitchSpeedControls={getShouldShowPitchSpeedControls()}

        showMixRecord={clientConfiguration.features.session.showMixRecord}
        pitch={pitch}
        speed={speed}
        onChangeSpeed={(v) => dispatch(changeGlobalPlaybackRate(v))}
        onSpeedMinus={() => dispatch(decreaseGlobalPlaybackRate())}
        onSpeedPlus={() => dispatch(increaseGlobalPlaybackRate())}
        onChangePitch={(v) => dispatch(changeGlobalPitch(v))}
        onPitchMinus={() => dispatch(decreaseGlobalPitchRate())}
        onPitchPlus={() => dispatch(increaseGlobalPitchRate())}
        getCurrentPosition={() => audioEngine.currentPosition / 1000}
        onChangePosition={handleUpdatePosition}
        onSelectSection={handleSelectSection}
        onSoloModeToggle={handleSoloModeToggle}
        soloMode={soloMode}
        onReset={handleMixReset}
        onMute={(v) => dispatch(toggleMasterMute())}
        song={{
          title: title,
          artist: artist,
          length: duration,
          sections: sections,
        }}
        onPlayPause={() => {
          if (playbackState === "playing") {
            dispatch(pauseSong());
          } else {
            dispatch(playSong());
          }
        }}

		onStop={handleStop}

        onRecord={() => dispatch(recordSong())}
        onLoop={handleOnLoop}
        isRecording={playbackState === "recording"}
        isPlaying={playbackState === "recording" || playbackState === "playing"}
        isMuted={isMasterMuted}
        isLooping={isLooping}
        loopStart={loopStart/1000}
        loopEnd={loopEnd/1000}
        showTransportControls={
          location.pathname === "/session" && status === "ready"
        }
      >
        <Routes>
          <Route path={`/session`} element={<Session />} />
          {clientConfiguration.features.setlist.enabled && (
            <Route path={`/my-setlist`} element={<MySetlist />} />
          )}
          {clientConfiguration.features.setlists.enabled && (
            <Route path={`/setlist/:id`} element={<Setlist />} />
          )}
          {clientConfiguration.features.setlists.enabled && (
            <Route path={`/setlist/create`} element={<CreateSetlist />} />
          )}
          {clientConfiguration.features.setlists.enabled && (
            <Route path={`/setlists`} element={<Setlists />} />
          )}
          <Route path={`/library`} element={<Library />} />

		  <Route path={`/ugc-library`} element={<UgcLibraryEditor />} />

          <Route path={`/help`} element={<Help />} />
          <Route path={`/settings`} element={<Settings />} />
          <Route path={`/experiments`} element={<Experiments />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </PlayerContainer>

      {feedbackModalVisible && (
        <FeedbackModal
          onClose={handleFeedbackModalClose}
          onSubmit={handleFeedbackModalSubmit}
        />
      )}
      {iOSModalVisible && <IOSModal onClose={handleIOSModalClose} />}
    </Main>
  ) : (
    <Navigate to="/" />
  );
};

export default Authenticated;
